export const EVENTS_LIMIT = 15;
export const EVENT_URL_PREFIX = "https://premiumseatsusa.com";
